import { TYPES } from "@/view/ProseMirrorNode/ProseMirrorNode.constants";

const getIsEditorsNote = (currentNode, index, allContentNodeData) => {
  const isParagraph = currentNode?.type === TYPES.paragraph;
  const paragraphChildNode = currentNode?.content?.[0];

  // Editor's notes will be in nodes with TYPES.paragraph and have a child node
  // that contains the text of the note.
  if (!isParagraph || !paragraphChildNode) return;

  // Editor's notes begin with "Editor's Note". The apostrophe can vary depending on
  // where the note was created, so we're checking for both.
  const startsWithEditorsNote =
    paragraphChildNode?.text?.startsWith("Editor's Note") ||
    paragraphChildNode?.text?.startsWith("Editor’s Note") ||
    paragraphChildNode?.text?.startsWith("Newsela Editor's Note") ||
    paragraphChildNode?.text?.startsWith("Newsela Editor’s Note");

  // Editor's notes should be italicized.
  const isItalicized = paragraphChildNode?.marks?.[0]?.type === "italic";

  if (index === 0 && !startsWithEditorsNote) {
    return false;
  }

  // We are assuming that all italicized paragraphs after an editor's note
  // are part of the editor's note.
  if (!startsWithEditorsNote && isItalicized) {
    const precedingNodes =
      index > 0 ? allContentNodeData?.slice(0, index) : null;
    const precedingNodeIndex = index - 1;

    return getIsEditorsNote(
      precedingNodes[precedingNodeIndex],
      precedingNodeIndex,
      allContentNodeData,
    );
  }

  return startsWithEditorsNote && isItalicized;
};

export default getIsEditorsNote;
